import Button from "components/button/Button";
import { EmailInput } from "components/input/EmailInput";
import PasswordInput from "components/input/PasswordInput";
import React, { useState, useRef, Fragment } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUser } from "redux/actions/userActions";
import { showToast, validateEmail } from "services/helper";
import {
  loginWithEmailAndPassword,
  requestResetPassword,
} from "services/requests";
import "./Login.scss";

function Login() {
  //STATE
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  //OTHERS
  const passwordRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleEnter(event, inputName) {
    if (event.key === "Enter") {
      if (!inputName) checkInputs();
      else if (inputName === "email") passwordRef.current.focus();
    }
  }

  function disableErrorMessage(field) {
    if (errors[field]?.length > 0) {
      errors[field] = "";
      setErrors({ ...errors });
    }
  }

  function checkInputs() {
    let newErrors = {};

    if (email?.length === 0 || !validateEmail(email))
      newErrors.email = "E-mail parece ser inválido.";
    if (password.length === 0 && !showForgotPasswordForm)
      newErrors.password = "Senha parece ser inválida.";

    const foundErrors = Object.keys(newErrors)?.length > 0;
    if (foundErrors) setErrors(newErrors);
    else {
      if (showForgotPasswordForm) sendEmail();
      else handleOnSubmit();
    }
  }

  function sendEmail() {
    setLoading(true);
    requestResetPassword(email)
      .then(() => {
        showToast("E-mail enviado com sucesso!", "success");
        setEmail("");
        setShowForgotPasswordForm(false);
      })
      .catch(() => {
        showToast(
          "Infelizmente não foi possível enviar o e-mail, tente novamente mais tarde.",
          "error"
        );
      })
      .finally(() => setLoading(false));
  }

  function handleOnSubmit() {
    setLoading(true);

    loginWithEmailAndPassword(email, password)
      .then((data) => {
        const { user } = { ...data };
        const { name } = { ...data?.user };

        if (user) {
          showToast(
            `Olá, ${name?.length > 0 ? name : "bom te ver novemente!"}`,
            "success"
          );
          dispatch(setUser(data));
          navigate("/");
        } else {
          setLoading(false);
          showToast(
            "Nenhum usuário encontrado, verifique suas credenciais.",
            "error"
          );
        }
      })
      .catch(() => {
        setLoading(false);
        showToast(
          "Infelizmente não foi possível acessar, verifique suas credenciais ou tente novamente mais tarde.",
          "error"
        );
      });
  }

  return (
    <div className="login-page">
      <div className="yellow-box">
        <h1>SEO</h1>
        <h2>Analyzer</h2>
      </div>

      <div className="form">
        <div className="inputs-container">
          {showForgotPasswordForm ? (
            <Fragment>
              <p id="email-text">
                Você receberá um e-mail para redefinir sua senha, por favor
                preencha o campo abaixo:
              </p>
              <EmailInput
                value={email}
                setValue={setEmail}
                error={errors.email}
                disableError={() => disableErrorMessage("email")}
                className="form-email-input"
                onKeyPress={handleEnter}
              />
            </Fragment>
          ) : (
            <Fragment>
              <EmailInput
                value={email}
                setValue={setEmail}
                error={errors.email}
                disableError={() => disableErrorMessage("email")}
                className="form-email-input"
              />
              <PasswordInput
                onChange={(text) => {
                  setPassword(text);
                  disableErrorMessage("password");
                }}
                id="txPassword"
                className="form-password-input"
                onKeyPress={handleEnter}
                error={errors.password}
              />
            </Fragment>
          )}
        </div>
        <p className="cursor-pointer">
          <span
            className="underline"
            onClick={() => setShowForgotPasswordForm(!showForgotPasswordForm)}
          >
            {showForgotPasswordForm ? "Entrar" : "Esqueceu a senha?"}
          </span>
        </p>
        <Button
          text={showForgotPasswordForm ? "Mandar e-mail" : "Entrar"}
          loading={loading}
          onClick={checkInputs}
        />
      </div>
    </div>
  );
}

export default Login;
